const collectionData = {
  companies: {
    interior: "popup-inner-add-company",
    order: "company_name",
    fields: ["Company", "Contact", "Address", "Email", "Phone", "Action"],
    fieldNames: ["company_name", "contact_name", "address", "email", "phone"],
  },
  adminCompanies: {
    fields: ["Company", "Type", "API Key", "Qwikr Key", "Action"],
    fieldNames: [
      "company_name",
      "company_type",
      "api_key",
      "qwikr_company_key",
    ],
  },
  companyApiKeys: {
    interior: "popup-inner",
    order: "company_name",
    fields: ["Company", "API Key", "Action"],
    fieldNames: ["company_name", "api_key"],
  },
  rateSheets: {
    order: "rs_name",
    fields: [
      "Name",
      "Method",
      "Type",
      "Created By",
      "Created At",
      "Updated By",
      "Updated At",
      "Action",
    ],
    fieldNames: [
      "rs_name",
      "method_name",
      "type_name",
      "created_by_name",
      "created_at",
      "updated_by_name",
      "updated_at",
    ],
    dropDowns: {
      haulingMethod: [
        { value: "per-st", label: "Per ST" },
        { value: "flat", label: "Flat" },
      ],
      haulingType: [
        { value: "tier-rates", label: "Tier Rates" },
        { value: "fixed-rates", label: "Fixed Rates" },
      ],
    },
  },
  tierdRateSheets: {
    order: "rs_name",
    fields: [
      "Name",
      "Customer",
      "Method",
      "Type",
      "Created By",
      "Created At",
      "Updated By",
      "Updated At",
      "Action",
    ],
    fieldNames: [
      "rs_name",
      "customer_name",
      "method_name",
      "type_name",
      "created_by_name",
      "created_at",
      "updated_by_name",
      "updated_at",
    ],
    dropDowns: {
      haulingMethod: [
        { value: "per-st", label: "Per ST" },
        { value: "flat", label: "Flat" },
      ],
      haulingType: [
        { value: "tier-rates", label: "Tier Rates" },
        { value: "fixed-rates", label: "Fixed Rates" },
      ],
    },
  },
  assetRateSheets: {
    order: "rs_name",
    fields: [
      "Name",
      "Method",
      "Type",
      "Asset Type",
      "Created By",
      "Created At",
      "Updated By",
      "Updated At",
      "Action",
    ],
    fieldNames: [
      "rs_name",
      "method_name",
      "type_name",
      "asset_type_name",
      "created_by_name",
      "created_at",
      "updated_by_name",
      "updated_at",
    ],
    dropDowns: {
      haulingMethod: [
        { value: "per-st", label: "Per ST" },
        { value: "flat", label: "Flat" },
        { value: "per-box", label: "Per Box" },
      ],
      haulingType: [
        { value: "tier-rates", label: "Tier Rates" },
        { value: "fixed-rates", label: "Fixed Rates" },
      ],
      assetType: [
        { value: "empty-box", label: "Empty Box" },
        { value: "full-box", label: "Full Box" },
        { value: "equipment", label: "Equipment" },
      ],
    },
  },
  fscRateSheets: {
    fields: [
      "Name",
      "Method",
      "Created By",
      "Created At",
      "Updated By",
      "Updated At",
      "Action",
    ],
    fieldNames: [
      "fsc_name",
      "method_name",
      "created_by_name",
      "created_at",
      "updated_by_name",
      "updated_at",
    ],
  },
  companyCarriers: {
    fields: ["Name", "Rate Percentage", "Action"],
    fieldNames: ["carrier_name", "rate_percentage"],
  },
  carrierDrivers: {
    fields: ["First Name", "Last Name", "Truck", "Trailer", "Rate %", "Action"],
    fieldNames: [
      "first_name",
      "last_name",
      "truck_no",
      "trailer_no",
      "rate_percentage",
    ],
  },
  companyLists: {
    fields: ["Name", "Type", "Action"],
    fieldNames: ["list_name", "list_type_name"],
  },
};

const invoiceStatus = {
  21: "Sent",
  22: "Disputed",
  23: "Approved",
  24: "Paid",
  25: "Not Sent",
};

const invoiceStatusStyles = {
  21: "status-sent",
  22: "status-disputed",
  23: "status-approved",
  24: "status-paid",
  25: "status-not-sent",
};

const vendorInvoiceStatus = {
  29: "Approved",
  30: "Disputed",
  31: "Paid",
  32: "Pending",
};

const invoiceStatusFilterMap = {
  in_progress: "In Progress",
  approved: "Approved",
  paid: "Paid",
  disputed: "Disputed",
};

const vendorInvoiceStatusStyles = {
  23: "status-approved",
  24: "status-approved",
  21: "status-not-sent",
  22: "status-disputed",
  25: "status-not-sent",
  0: "status-disputed",
};

const billingPrefrenceOptions = [
  { value: 26, label: "Default" },
  { value: 27, label: "Confirmed" },
  { value: 28, label: "Approved" },
  { value: 41, label: "Confirmed+Default" },
  { value: 42, label: "Approved+Default" },
];

const loadApprovalStatus = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "consfirmed", label: "Confirmed" },
  { value: "approved", label: "Approved" },
  { value: "paid", label: "Paid" },
  { value: "disputed", label: "Disputed" },
  { value: "canceled", label: "Canceled" },
];

const companyTypeOptions = [
  { value: 0, label: "All Vendor Types" },
  { value: 2, label: "Carrier" },
  { value: 33, label: "Driver" },
  { value: 34, label: "Account Company" },
];

const loadBatchActionOptions = [{ value: 0, label: "Hard Refresh" }];

const monthOptions = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export {
  collectionData,
  loadApprovalStatus,
  invoiceStatus,
  invoiceStatusStyles,
  vendorInvoiceStatus,
  vendorInvoiceStatusStyles,
  billingPrefrenceOptions,
  invoiceStatusFilterMap,
  monthOptions,
  companyTypeOptions,
  loadBatchActionOptions,
};
